import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import styles from './Styles.css'
// import { Button } from '@mui/material';

export const NewScreenDisplay = ({apiConfig, open, onClose, onSubmit}) => {

    const [screenDisplay, setScreenDisplay] = useState({
      ScreenName: "", ScreenDisplayDuration: 0, CreatedBy: "system", UpdatedBy: "system"
    })

    const handleChange = (e) => {
      setScreenDisplay({
          ...screenDisplay,
          [e.target.name]: e.target.value
        });
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Screen Display Data:', screenDisplay);
        // You can handle form submission logic here
        apiConfig.createAIScreenDisplay(screenDisplay).then((response)=>{
          onSubmit(response.RobotResponse);
        })
    };

  return(
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box component="form" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '50%',
          height: '50%',
          bgcolor: 'background.paper',
          border: '2px solid',
          borderColor: 'divider',
          borderRadius: 10,
          boxShadow: 24,
          p: 4,
          overflowY: "auto"
        }}
        onSubmit={handleSubmit}
        >
          <Grid container spacing={3} >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <p className={styles.font}>New Screen Display</p>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                  style={{width: "100%"}}
                  label="Screen Name"
                  variant="outlined"
                  name="ScreenName"
                  value={screenDisplay.ScreenName}
                  onChange={handleChange}
                  required
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <TextField
                  style={{width: "100%"}}
                  label="Screen Display Duration"
                  variant="outlined"
                  name="ScreenDisplayDuration"
                  type='number'
                  InputProps={{ inputProps: { min: 0 } }}
                  value={screenDisplay.ScreenDisplayDuration}
                  onChange={handleChange}
                  required
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button type="submit" variant="contained" color="primary">
                  Submit
              </Button>
            </Grid>
          </Grid>
      </Box>
    </Modal>
  )
}